import {environment} from 'src/environments/environment';

export const DEBOUNCE_VALUE = 300;

export const LANG_KEY = 'locale';
export const TOKEN_KEY = 'token';
export const CLIENT_TOKEN = 'clientToken';
export const SELECTED_CLIENT = 'selectedClient';
export const SELECTED_CLIENT_ID = 'selectedClientId';
export const SELECTED_MANAGER_ID = 'selectedManagerId';
export const PREVIOUS_URL_FOR_REDIRECT_BACK = 'previousUrl';

export const KRONAS_MAIN_URL = 'https://kronas.com.ua/';
export const KRONAS_MASTER_URL = environment.masterKronasUrl;
export const NEW_PERSONAL_URL = environment.newPesonal;
